import { Row } from 'antd';
import styled from 'styled-components';

import CommonButton from '~atoms/CommonButton';

export const FooterContainer = styled(Row)({
  gap: '24rem',
  justifyContent: 'flex-end',
});

export const FooterButton = styled(CommonButton)(({ theme }) => ({
  height: '38rem',
  paddingInline: '20rem',
  marginBlockStart: '25rem',

  fontSize: theme.typography.size20,
}));
